export default __webpack_public_path__ + "static/TeeMates-a7dd3cfee5002350cd3d075ddbfe6d9c.webp";